import React from "react";
import PropTypes from "prop-types";

function goToSignInFresh() {
  try {
    sessionStorage.removeItem("native_auth_tokens");
  } catch {
    /* ignore */
  }
  window.location.assign("/signin");
}

/**
 * App-level error boundary. Previously an uncaught render/lifecycle error (most commonly a component
 * rendering against an expired session after long idle) unmounted the whole React tree and left a
 * blank white screen. This catches it and shows a recoverable fallback with a sign-in action instead.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] caught:", error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (!hasError) return children;
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f6f4fa",
          fontFamily: "Segoe UI, system-ui, sans-serif",
          padding: 24,
        }}
      >
        <div
          style={{
            maxWidth: 440,
            textAlign: "center",
            background: "#fff",
            border: "1px solid #e6e1ee",
            borderRadius: 14,
            padding: "32px 28px",
            boxShadow: "0 6px 24px rgba(82,0,155,0.08)",
          }}
        >
          <div style={{ fontSize: 34, marginBottom: 8 }}>⏳</div>
          <h2 style={{ margin: "0 0 8px", color: "#17131f", fontSize: 20 }}>
            Your session has expired
          </h2>
          <p style={{ margin: "0 0 22px", color: "#6a6478", fontSize: 14, lineHeight: 1.5 }}>
            You were inactive for a while, or something went wrong. Please sign in again to continue
            — your saved work is safe.
          </p>
          <button
            type="button"
            onClick={goToSignInFresh}
            style={{
              background: "#52009b",
              color: "#fff",
              border: "none",
              borderRadius: 9,
              padding: "11px 26px",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Sign in again
          </button>
        </div>
      </div>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
